export const UPLOAD_CANCEL = 'upload/CANCEL';
export const UPLOAD_FAILURE = 'upload/FAILURE';
export const UPLOAD_PROGRESS = 'upload/PROGRESS';
export const UPLOAD_RETRY = 'upload/RETRY';
export const UPLOAD_START = 'upload/START';
export const UPLOAD_SUCCESS = 'upload/SUCCESS';
